const GS1_BARCODE_REGEXP = /^01(\d{14})((15\d{6})|(21\w{1,20})|(11\d{6})|(17\d{6})|(10\w{1,20})).*/;

export const extractGtin14FromBarcode = barcode => {
  if (!barcode || typeof barcode !== 'string') {
    return null;
  }
  const match = barcode.match(GS1_BARCODE_REGEXP);
  return match ? match[1] : null;
};
